import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { ProductPositionFormOptions } from "features/product-position-management/types/ProductPositionFormOptions"
import { ProjectPageProductPositionSidebar } from "pages/project-page/sidebar/product-position/ProjectPageProductPositionSidebar"

import { useSharedProjectPageProductPositionSidebarModel } from "../hooks/useSharedProjectPageProductPositionSidebarModel"

export interface SharedProjectPageProductPositionSidebarProps {
  projectID: string
  productPosition: ProductPosition
}

const FORM_OPTIONS: ProductPositionFormOptions = {
  hideOpenProductConfigurationLink: true,
  hideInstallationReferenceSelectionLink: true
}

export const SharedProjectPageProductPositionSidebarConnector = React.memo(
  (props: SharedProjectPageProductPositionSidebarProps) => (
    <ProjectPageProductPositionSidebar
      {...useSharedProjectPageProductPositionSidebarModel(props)}
      formOptions={FORM_OPTIONS}
      hideControls
    />
  )
)
